export { CorporativoRegional } from "./CorporativoRegional";
